import {
  SUPPORT_REQUEST,
  CONFORMITY_REPORT,
  SUPPORT_REQUEST_COLLABORATION,
  CONFORMITY_REPORT_COLLABORATION
} from 'fixtures/api'
import {
  ROUTE_DASHBOARD,
  ROUTE_DASH_TASKS,
  ROUTE_SUPPORT_REQ_LIST,
  ROUTE_CONFORMITY_LIST
} from 'fixtures/routes'

export const notifRouteHelper = (type, id) => {
  const taskRoute = `/${ROUTE_DASHBOARD}/${ROUTE_DASH_TASKS}`
  let fullRoute

  switch (type) {
    case SUPPORT_REQUEST:
      fullRoute = `${taskRoute}/${ROUTE_SUPPORT_REQ_LIST}/${id}`
      break;
    case CONFORMITY_REPORT:
      fullRoute = `${taskRoute}/${ROUTE_CONFORMITY_LIST}/${id}`
      break;
    case SUPPORT_REQUEST_COLLABORATION:
      fullRoute = `${taskRoute}/${ROUTE_SUPPORT_REQ_LIST}/${id}`
      break;
    case CONFORMITY_REPORT_COLLABORATION:
      fullRoute = `${taskRoute}/${ROUTE_CONFORMITY_LIST}/${id}`
      break;
    default:
      break;
  }

  return fullRoute
}
